import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/novel/novelList')
    },
    {
        path: '/webSucc/:item_id',
        name: 'webSucc',
        component: () => import('@/views/pay/webSucc')
    },
    {
        path: '/webFail/:item_id',
        name: 'webFail',
        component: () => import('@/views/pay/webFail')
    },
    {
        path: '/appSucc/:item_id',
        name: 'appSucc',
        component: () => import('@/views/pay/appSucc')
    },
    {
        path: '/appFail/:item_id',
        name: 'appFail',
        component: () => import('@/views/pay/appFail')
    },
    {
        path: '/view/:novel_id',
        name: 'view',
        component: () => import('@/views/novel/novelInfo')
    },
    {
        path: '/read/:novel_id/:chapter_id',
        name: 'read',
        component: () => import('@/views/novel/novelRead'),
    },
    {
        path: '/favorite',
        name: 'favorite',
        component: () => import('@/views/novel/novelFavorite')
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import('@/views/pay/privacyView')
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import('@/views/pay/termsView')
    },
    {
        path: '/refund',
        name: 'refund',
        component: () => import('@/views/pay/refundView')
    },
    {
        path: '/me',
        name: 'me',
        component: () => import('@/views/novel/novelMe')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/novel/novelLogin')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/novel/novelReg')
    },
    {
        path: '/change',
        name: 'change',
        component: () => import('@/views/novel/changePwd')
    },
    {
        path: '/forgot',
        name: 'forgot',
        component: () => import('@/views/novel/forgotPwd')
    },
    {
        path: '/setting',
        name: 'setting',
        component: () => import('@/views/novel/novelSetting')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/novel/novelAbout')
    },
    {
        path: '/upload',
        name: 'upload',
        component: () => import('@/views/upload/novelUpload'),
    },
    {
        path: '/pay',
        name: 'pay',
        component: () => import('@/views/pay/webMenu'),
    },
    {
        path: '/maxMenu',
        name: 'maxMenu',
        component: () => import('@/views/maxPay/maxMenu'),
    },
    {
        path: '/maxRes/:token/:content_id/:content_type',
        name: 'maxRes',
        component: () => import('@/views/maxPay/maxRes')
    },
    {
        path: '/doitMenu',
        name: 'doitMenu',
        component: () => import('@/views/doitPay/doitMenu'),
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('@/views/novel/novelHelp'),
    },
    {
        path: '/contentPolicy',
        name: 'contentPolicy',
        component: () => import('@/views/pay/contentPolicy'),
    },
    {
        path: '/notify',
        name: 'novNotify',
        component: () => import('@/views/notify/novNotify'),
    },
    {
        path: '/subscription',
        name: 'novSubscription',
        component: () => import('@/views/subscription/novSubscription'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes
});

export default router;